/** en 文案聚合：每个命名空间一份 JSON，key 树以 en 为准；缺的 key 运行时回落 en。 */
import common from './common.json' with { type: 'json' }
import auth from './auth.json' with { type: 'json' }
import feed from './feed.json' with { type: 'json' }
import player from './player.json' with { type: 'json' }
import pay from './pay.json' with { type: 'json' }
import drama from './drama.json' with { type: 'json' }
import library from './library.json' with { type: 'json' }
import onboarding from './onboarding.json' with { type: 'json' }
import landing from './landing.json' with { type: 'json' }
import account from './account.json' with { type: 'json' }
import visualGame from './visual-game.json' with { type: 'json' }
import legal from './legal.json' with { type: 'json' }

export default { common, auth, feed, player, pay, drama, library, onboarding, landing, account, visualGame, legal }
